import { Dashboard, PageNotFound } from '@/components';

export const NotFoundPage = () => (
  <Dashboard>
    <PageNotFound />
  </Dashboard>
);
